import React from 'react';
import { TargetIcon, PenToolIcon, LayoutTemplateIcon, MailIcon, ZapIcon, MegaphoneIcon, BrainIcon, BarChart3Icon } from 'lucide-react';
import { Reveal } from './Reveal';
const experts = [{
  n: '01',
  icon: TargetIcon,
  name: 'Offer Clarity',
  role: 'Tu Estratega'
}, {
  n: '02',
  icon: PenToolIcon,
  name: 'Copy Writer',
  role: 'Tu Vendedor'
}, {
  n: '03',
  icon: LayoutTemplateIcon,
  name: 'Page Builder',
  role: 'Tu Arquitecto'
}, {
  n: '04',
  icon: MailIcon,
  name: 'Email Launch',
  role: 'Tu Seguimiento'
}, {
  n: '05',
  icon: ZapIcon,
  name: 'Hook Generator',
  role: 'Tu Viralizador'
}, {
  n: '06',
  icon: MegaphoneIcon,
  name: 'Ad Creative',
  role: 'Tu Director Creativo'
}, {
  n: '07',
  icon: BrainIcon,
  name: 'Launch Brain',
  role: 'Tu General de Campo'
}, {
  n: '08',
  icon: BarChart3Icon,
  name: 'Launch Analyzer',
  role: 'Tu Científico de Datos'
}];
export function ExpertsSection() {
  return <section className="w-full bg-black py-12 sm:py-24" data-id="element-49">
      <div className="mx-auto max-w-6xl px-4" data-id="element-50">
        <Reveal data-id="element-51">
          <h2 className="text-center font-display text-2xl text-white sm:text-4xl" data-id="element-52">
            Los <span className="text-orange-500" data-id="element-53">8 Expertos</span> que trabajan
            para ti
          </h2>
        </Reveal>

        <div className="mt-8 grid gap-4 sm:mt-12 sm:grid-cols-2 lg:grid-cols-4" data-id="element-54">
          {experts.map(({
          n,
          icon: Icon,
          name,
          role
        }, i) => <Reveal key={n} delay={i % 4 * 0.06} data-id="element-55">
              <article className="group h-full rounded-2xl border border-zinc-800 bg-zinc-900/60 p-6 transition-colors duration-200 hover:border-orange-500/50" data-id="element-56">
                <div className="flex items-center justify-between" data-id="element-57">
                  <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-orange-500/10 text-orange-500" data-id="element-58">
                    <Icon className="h-6 w-6" aria-hidden="true" data-id="element-59" />
                  </span>
                  <span className="font-display text-2xl text-zinc-700 transition-colors group-hover:text-orange-500/60" data-id="element-60">
                    {n}
                  </span>
                </div>
                <h3 className="mt-5 font-display text-lg text-white" data-id="element-61">{name}</h3>
                <p className="mt-1 text-sm font-medium text-amber-400" data-id="element-62">
                  {role}
                </p>
              </article>
            </Reveal>)}
        </div>
      </div>
    </section>;
}